import { render, staticRenderFns } from "./row-editor.vue?vue&type=template&id=2a135706"
import script from "./row-editor.vue?vue&type=script&lang=js"
export * from "./row-editor.vue?vue&type=script&lang=js"
import style0 from "./row-editor.vue?vue&type=style&index=0&id=2a135706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports